import { PropsWithChildren } from 'react';
import * as styles from './Popup.css';
import Text from './Text/Text';
import Title from './Title/Title';

const Popup = ({ children }: PropsWithChildren) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>{children}</div>
    </div>
  );
};

Popup.Text = Text;
Popup.Title = Title;

export default Popup;
